import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { UserProvider } from './Context/UserContext';

const isProduction = process.env.NODE_ENV === 'production';

if(isProduction){
  Sentry.init({
    dsn: "https://74e27c9cf221ee06ab5d207f8f3bf242@o4509145884721152.ingest.us.sentry.io/4509145890488320",
  });
}

const rootElement = document.getElementById('root');
const appElement = (
  <UserProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </UserProvider>
);

const root = ReactDOM.createRoot(rootElement);
root.render(appElement);